import React, { useMemo } from "react";
import PropTypes from "prop-types";
//Styles
import styled, { withTheme } from "styled-components";
//components
import { Link, Icon, ScreenReaderText, Title } from "../../atoms";
import { HorizontalListMolecule, ListItemMolecule } from "../../molecules";

const PublicNavbar = ({
  className,
  isLogin,
  loginClick,
  links,
  social,
  theme,
  lang,
  ...props
}) => {
  const iconNames = useMemo(() => {
    return { 2: theme.icons.facebook, 3: theme.icons.instagram };
  }, [theme.icons.facebook, theme.icons.instagram]);

  return (
    <nav className={className} {...props}>
      <ScreenReaderText>
        <Title text="Navegação de Públicos" />
      </ScreenReaderText>
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-3">
            <HorizontalListMolecule
              display="inline-block"
              spacing="0"
              className="public-social-links"
            >
              {social.map((item, index) => {
                return (
                  <ListItemMolecule lineHeight="20px" height="20px" key={index}>
                    <Link
                      target={item.target}
                      tabIndex={0}
                      aria-label={item.ariaLabel}
                      href={item.url}
                      fontSize="12px"
                      native={item.onlyIcon}
                      color={theme.components.publicNavbar.linksColor}
                    >
                      {item.onlyIcon ? (
                        <Icon
                          fontSize="12px"
                          aria-label={item.title}
                          name={iconNames[index]}
                          cursor="pointer"
                          color={theme.components.publicNavbar.iconColor}
                        />
                      ) :
                        item.title
                      }
                    </Link>
                  </ListItemMolecule>
                );
              })}
            </HorizontalListMolecule>
          </div>

          <div className="col">
            <HorizontalListMolecule display="inline-block">
              {links.map((item, index) => {
                return (
                  <ListItemMolecule
                    marginRight="15px"
                    lineHeight="20px"
                    height="20px"
                    key={index}
                  >
                    <Link
                      tabIndex={0}
                      fontWeight="300"
                      href={item.url}
                      target={item.target}
                      aria-label={item.title}
                      fontSize="12px"
                      color={theme.components.publicNavbar.linksColor}
                    >
                      {item.title}
                    </Link>
                  </ListItemMolecule>
                );
              })}
            </HorizontalListMolecule>
          </div>
        </div>
      </div>
    </nav>
  );
};

PublicNavbar.propTypes = {
  className: PropTypes.string,
  isLogin: PropTypes.bool.isRequired,
  loginClick: PropTypes.func,
  links: PropTypes.array.isRequired,
  social: PropTypes.array.isRequired,
  auth: PropTypes.object,
  lang: PropTypes.string
};

PublicNavbar.defaultProps = {
  name: "fa-info",
  cursor: "default",
  lang: "pt",
  loginClick: () => {}
};

const PublicNavBarWithStyles = styled(PublicNavbar)`
  width: 100%;
  height: 40px;
  background: ${props => props.theme.components.publicNavbar.backgroundColor};
  display: flex;
  align-items: center;

  .public-social-links {
    li {
      padding-right: 12px;
      padding-left: 12px;
      border-left: 1px solid
        ${props => props.theme.components.publicNavbar.borderColor};
      :first-child {
        padding-left: 0;
        border-left: none;
      }
      :last-child {
        padding-right: 0;
      }
    }
  }
`;

export default withTheme(PublicNavBarWithStyles);